import React from 'react';
import { useStoreState } from 'base/store';
import AffirmPayInfo from '@base/common/payMent/AffirmPay/AffirmPayInfo';
import RemindModal from '@base/common/payMent/RemindModal';
import styles from './index.module.less';
import Image from '@base/lib/ThemeImage';
import { isPhone } from 'base/utils/client';
import cn from 'classnames';

type IProps = {
    className?: string;
    children?: any;
}

const AffirmPayRemindModal: React.FC<IProps> = (props) => {
    const { children, className } = props

    return (
        <RemindModal
            className={className}
            modalContent={<AffirmPayInfo showTitle={!isPhone}/>}
            modalTitle={(<div className={cn(styles['title-img'], 'flex flex-middle flex-center')}>
                <Image
                    src={'asset/width-264/picture/3886cb9b28d65ff863c8f97e2369e917.png'}
                    width={66}
                    height={26}
                    background={false}
                    fixed
                />
            </div>)}
            modalProps={{
                width: isPhone ? '100%' : 568,
                className: styles['modal-wrap']
            }}
        >
            {children}
        </RemindModal>
    )
};

export default AffirmPayRemindModal;